module.exports = __webpack_public_path__ + "img/add_icon-2.3180cc91.svg";